export const MINUTE = 'MINUTE';
export const HOUR = 'HOUR';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/DateTimePicker/TimeComponents/TimeConstants.js